import http from './http';

//社区文章列表
/*
category_id	string			
分类ID  
keyword	string			
标题｜标签  
is_recom	string		0	
1是否推荐  
order	string		sort asc	
sort asc默认最新  
搜索热门 desc，
comment_number 评论最多,
page_size	int		15	
当前条数  
page	int		1	
当前页  
当前页  
*/
export function getCommunityList(data: { category_id: string; keyword: string;type?:string;is_recom?:string;order?:string; page_size?: number; page?: number }) {
  const params = new URLSearchParams();
  if (data.category_id !== undefined && data.category_id !== null && data.category_id !== '') params.append('category_id', data.category_id);
  if (data.keyword !== undefined && data.keyword !== null && data.keyword !== '') params.append('keyword', data.keyword);
  if (data.is_recom !== undefined && data.is_recom !== null && data.is_recom !== '') params.append('is_recom', data.is_recom);
  if (data.order !== undefined && data.order !== null && data.order !== '') params.append('order', data.order);
  if (data.page_size !== undefined && data.page_size !== null) params.append('page_size', String(data.page_size));
  if (data.page !== undefined && data.page !== null) params.append('page', String(data.page));
  if (data.type !== undefined && data.type !== null) params.append('type', String(data.type));
  return http.get(`/community/index?${params.toString()}`);
}
//发帖
/**
 * 
 * @param data 
 * category_id	string			
分类ID  
title	string			
标题  
content	string			
文章内容  
 * @returns 
 */
export function getCommunityAdd(data: { category_id: string;title: string;content: string}) {
  
  return http.post(`/community/add`,data);
}
// //新闻详情
// export function getNewsDetails(data: { id: string;}) {
//   const params = new URLSearchParams();
//   if (data.id) params.append('id', data.id);
//   return http.get(`/news/details?${params.toString()}`);
// }
//社区分类
export function getCommunityCategorys() {
  return http.get('/community/categorys');
}
//社区标签
export function getCommunityTags() {
  return http.get('/community/tags');
}

//社区文章点赞添加
export function getcommunityLikeAdd(data: { id: string;}) {
  return http.post(`/communityLike/add`,data);
}
//社区文章点赞取消
export function getcommunityLikeOut(data: { id: string;}) {
  return http.post(`/communityLike/out`,data);
}

////社区文章添加评论
/*
id	string			
文章ID  
pid	string			
上级ID，多级回复，没有则为0  
content	string			
评论内容  
*/
export function getcommunityCommentAdd(data: { id: string;pid?: string;content: string}) {
  return http.post(`/communityComment/add`,data);
}

//社区文章评论列表
/*
id	string
ID*/
export function getcommunityCommentList(data: { id: string; }) {
  const params = new URLSearchParams();
  if (data.id) params.append('id', data.id);
  return http.get(`/communityComment/index?${params.toString()}`);
}

//评论回复提醒


export function getcommunityCommentReply() {
  return http.get(`/communityComment/reply`);
}

//关注列表
export function getcommunityFocusList() {
  return http.get(`/userFans/index`);
}
//关注作者添加
export function getcommunityFocusAdd(data: { id: string;}) {
  return http.post(`/userFans/add`,data);
}
//关注作者取消
export function getcommunityFocusOut(data: { user_id: string;}) {
  return http.post(`/userFans/out`,data);
}